import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-add-respondent-loading-state',
  template: `
    <div
      class="mx-auto flex max-w-[60%] flex-col items-center justify-center gap-5 py-8 text-center text-lg"
    >
      <img
        class="h-12 w-12"
        src="../../../../../../assets/images/ai-initiate-assistant.gif"
        alt="Loading indicator"
      />
      <div class="flex flex-col items-center justify-center gap-2">
        <span class="font-medium text-slate-900">Upload in progress</span>
        <span class="text-sm leading-6 text-slate-600">
          Please keep this window open until your upload is complete
        </span>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'flex min-h-[400px] items-center justify-center',
  },
  standalone: false,
})
export class AddRespondentLoadingStateComponent {}
